import {
  GET_NOA_GROUP_REPORT,
  GET_NOA_GROUP_REPORT_SPC_COMPANY_LIST,
  GET_NOA_GROUP_REPORTS,
  POST_NOA_GROUP_REPORT,
  DELETE_NOA_GROUP_REPORT,
  GET_AVAILABLE_SPC_FOR_NOA_GROUP_REPORT,
} from "../constants/actionTypes";

const defaultState = {
  noaGroupList: [],
  noaGroupSPCCompanyDetailsList: [],
  serviceProvider: null,
  groupReport: null,
  customers: [],
  availableSPCList: [],
};

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_NOA_GROUP_REPORTS:
        return {
          ...state,
          noaGroupList: action.payload,
        };
      case DELETE_NOA_GROUP_REPORT:
        return {
          ...state,
          noaGroupList: (state.noaGroupList || []).filter(
            (item) => String(item?.id) !== String(action.payload),
          ),
        };
      case GET_NOA_GROUP_REPORT:
        return {
          ...state,
          serviceProvider: action.payload?.service_provider || null,
          groupReport: action.payload?.group_report || null,
          customers: action.payload?.customers || [],
        };
      case GET_NOA_GROUP_REPORT_SPC_COMPANY_LIST:
        return {
          ...state,
          noaGroupSPCCompanyDetailsList: action.payload ? action.payload : [],
        };
      case POST_NOA_GROUP_REPORT:
        return {
          ...state,
        };
      case GET_AVAILABLE_SPC_FOR_NOA_GROUP_REPORT:
        return {
          ...state,
          availableSPCList: action.payload ? action.payload : [],
        };
      default:
        return state;
    }
  } catch (error) {
    console.error("Reducer error:", error);
    return state;
  }
};
